module.exports = __webpack_public_path__ + "img/logo-u82.d99c657c.svg";